import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User } from "@app/models/user";
import { Observable, of } from "rxjs";

export const userOne: any = {
  createdUserId: "20b43ba3-1286-40b5-9a8f-1cff7356c204",
  createdUserUsername: null,
  createdUserFullname: null,
  createdUserEmail: null,
  createdDate: "2022-03-01T04:41:25.750+00:00",
  updatedUserId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
  updatedUserUsername: "superadmin",
  updatedUserFullname: "Super Admin",
  updatedUserEmail: "superadmin@cityline.com.hk",
  updatedDate: "2022-10-27T08:05:31.535+00:00",
  version: 12,
  userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
  username: "superadmin",
  userPassword: "fd4bee1bccb37f295a9bb307e2f3b691c70ee26fae3fac138b9a593c8c35f16b2dc9e5afcea0e23e",
  fontEndPassword: null,
  firstName: "Super",
  lastName: "Admin",
  userEmail: "superadmin@cityline.com.hk",
  status: "ENABLED",
  roles: [
    {
      createdUserId: "20b43ba3-1286-40b5-9a8f-1cff7356c204",
      createdUserUsername: null,
      createdUserFullname: null,
      createdUserEmail: null,
      createdDate: "2022-03-01T04:41:25.560+00:00",
      updatedUserId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      updatedUserUsername: null,
      updatedUserFullname: null,
      updatedUserEmail: null,
      updatedDate: "2022-11-01T09:25:32.251+00:00",
      version: 165,
      roleId: "269e4876-8a33-4df3-ba6a-3b902b297d27",
      roleCode: "SUPER_ADMIN",
      type: "ADMIN",
      roleName: {
        i18nStringMapId: "12d6aaa0-5f83-494c-b8e4-824ea954b05b",
        i18nStrings: [
          {
            i18nStringId: "b22c8296-262d-4d7a-8c2c-3d9ba28e2505",
            locale: "zh_CN",
            value: "Super Admin2",
          },
          {
            i18nStringId: "e82fe02d-880d-4c0d-abf7-0f291fe97378",
            locale: "en",
            value: "Super Admin2",
          },
          {
            i18nStringId: "70007812-1ba0-436e-bf60-0e9f042861d6",
            locale: "zh_TW",
            value: "Super Admin2",
          },
        ],
      },
      remarks: null,
      permissionSets: [
        {
          permissionSetId: "e0de6341-4b10-4401-8544-8ac111ab8d56",
          code: "PERM_SET_ADMIN_LOGIN",
          sequence: 0,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "69443c6c-6665-4f6d-8af7-cf50d9fa936d",
              code: "PERM_ADMIN_LOGIN",
              name: "PERM_ADMIN_LOGIN",
              sequence: 0,
              description: null,
              type: "ADMIN",
            },
            {
              permissionId: "029576dd-d2e1-46c2-811a-9d0ad02fdcd8",
              code: "PERM_USER_CHANGE_SELF_PASSWORD",
              name: "PERM_USER_CHANGE_SELF_PASSWORD",
              sequence: 1,
              description: null,
              type: "ADMIN",
            },
            {
              permissionId: "ec5a413e-8592-4ab5-a346-25013ed372b3",
              code: "PERM_USER_SELF_READ",
              name: "PERM_USER_SELF_READ",
              sequence: 2,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "20f999d3-830d-4bf5-b788-3896d65681d9",
          code: "PERM_SET_ROLE_CREATE",
          sequence: 1,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "12cffed0-c8e4-43ea-ab16-bf4e249d8f4b",
              code: "PERM_ROLE_CREATE",
              name: "PERM_ROLE_CREATE",
              sequence: 3,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "523c227c-f84d-415d-a666-c0ca72479035",
          code: "PERM_SET_ROLE_READ",
          sequence: 2,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "a42bd5f0-2c3c-41f3-85a1-91ff356452e0",
              code: "PERM_ROLE_READ",
              name: "PERM_ROLE_READ",
              sequence: 4,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "2dca24c8-0fea-4197-8df3-35cd717d8eab",
          code: "PERM_SET_ROLE_UPDATE",
          sequence: 3,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "7fa17bfc-bcf6-4be5-821c-a957f1481996",
              code: "PERM_ROLE_UPDATE",
              name: "PERM_ROLE_UPDATE",
              sequence: 5,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "85d64c9b-7a52-41bb-a59f-e273e9839f82",
          code: "PERM_SET_USER_CREATE",
          sequence: 4,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "d39b4ac5-7fb2-4847-b48d-312f2acb33bb",
              code: "PERM_USER_CREATE",
              name: "PERM_USER_CREATE",
              sequence: 6,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "3174b16f-77e5-4ea7-a3b5-03fa39739cb9",
          code: "PERM_SET_USER_UPDATE",
          sequence: 5,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "e4ed0b86-cf06-406c-bf61-50daafecf66f",
              code: "PERM_USER_UPDATE",
              name: "PERM_USER_UPDATE",
              sequence: 7,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "7088876e-48e2-46cb-8124-e2e157c3740b",
          code: "PERM_SET_USER_READ",
          sequence: 6,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "0e92f72d-f0f8-480d-b588-b1fbf7d075ce",
              code: "PERM_USER_READ",
              name: "PERM_USER_READ",
              sequence: 8,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "f1dcbedc-6e63-4c68-940f-f9e67c78f181",
          code: "PERM_SET_WORKFLOW_FORM_CREATE",
          sequence: 7,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "358ff957-822d-4d8d-afad-fd674c142d18",
              code: "PERM_WORKFLOW_FORM_CREATE",
              name: "PERM_WORKFLOW_FORM_CREATE",
              sequence: 9,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "fd757924-ddb5-4c5c-a695-735243eb9932",
          code: "PERM_SET_WORKFLOW_FORM_UPDATE",
          sequence: 8,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "b9269320-945c-4c2d-b1b1-4115c95d4feb",
              code: "PERM_WORKFLOW_FORM_UPDATE",
              name: "PERM_WORKFLOW_FORM_UPDATE",
              sequence: 10,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "67b8e07f-3be8-4e65-b8f7-7e20b8ec8001",
          code: "PERM_SET_WORKFLOW_FORM_READ",
          sequence: 9,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "51602072-0d94-4a01-be64-34e0efc2b5f4",
              code: "PERM_WORKFLOW_FORM_READ",
              name: "PERM_WORKFLOW_FORM_READ",
              sequence: 11,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "1cf02a5d-851b-407e-9a0e-26540e26b61e",
          code: "PERM_SET_CASE_INFO_CREATE",
          sequence: 10,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "c6d16c5d-d02b-4d4c-812f-c0fe89f22c48",
              code: "PERM_CASE_INFO_CREATE",
              name: "PERM_CASE_INFO_CREATE",
              sequence: 12,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "a4085496-13b0-4f3e-b31b-8aa4ea4fedd1",
          code: "PERM_SET_CASE_INFO_UPDATE",
          sequence: 11,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "d4d6191e-4437-4e37-afce-2f5005c8608e",
              code: "PERM_CASE_INFO_UPDATE",
              name: "PERM_CASE_INFO_UPDATE",
              sequence: 13,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "25b6aca3-436c-4135-878a-799b11f7bd10",
          code: "PERM_SET_CASE_INFO_READ",
          sequence: 12,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "8f133cf2-2061-46f6-86d0-968e78583a7d",
              code: "PERM_CASE_INFO_READ",
              name: "PERM_CASE_INFO_READ",
              sequence: 14,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "6e59ac13-a603-43b3-843f-6109c7286cfc",
          code: "PERM_SET_PROCESS_WORKFLOW_CREATE",
          sequence: 13,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "cf78eafa-cddb-49ae-a708-136276d7a76e",
              code: "PERM_PROCESS_WORKFLOW_CREATE",
              name: "PERM_PROCESS_WORKFLOW_CREATE",
              sequence: 15,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "3bc31056-9026-4bf4-8daa-014e116b8ed7",
          code: "PERM_SET_PROCESS_WORKFLOW_UPDATE",
          sequence: 14,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "d19b6b61-a5a9-4bfc-86ec-9fc10bc0599a",
              code: "PERM_PROCESS_WORKFLOW_UPDATE",
              name: "PERM_PROCESS_WORKFLOW_UPDATE",
              sequence: 16,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "4cd04cfc-725c-4598-835e-d18b7f03b129",
          code: "PERM_SET_PROCESS_WORKFLOW_READ",
          sequence: 15,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "aea5c823-c9d3-4cea-824a-079447be146e",
              code: "PERM_PROCESS_WORKFLOW_READ",
              name: "PERM_PROCESS_WORKFLOW_READ",
              sequence: 17,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "fdb18e77-d7aa-4afa-908d-ee84dfa9893c",
          code: "PERM_SET_PROCESS_WORKFLOW_POST",
          sequence: 16,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "2f47ea71-d623-4f30-9fa1-b6668b94533b",
              code: "PERM_PROCESS_WORKFLOW_POST",
              name: "PERM_PROCESS_WORKFLOW_POST",
              sequence: 18,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "e7f42541-90b3-478d-9f10-93ed4777a796",
          code: "PERM_SET_PROCESS_WORKFLOW_DISCARD",
          sequence: 17,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "27c544ce-0126-49b7-9f71-352ff423c267",
              code: "PERM_PROCESS_WORKFLOW_DISCARD",
              name: "PERM_PROCESS_WORKFLOW_DISCARD",
              sequence: 19,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "168f0424-55cf-424d-be55-f8d366a97afe",
          code: "PERM_SET_RECEIPT_CREATE",
          sequence: 18,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "e63fe2c0-97fc-4002-827e-4348299c1770",
              code: "PERM_RECEIPT_CREATE",
              name: "PERM_RECEIPT_CREATE",
              sequence: 20,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "db348c98-a6cb-4b9b-a3f8-272271553399",
          code: "PERM_SET_RECEIPT_UPDATE",
          sequence: 19,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "3572fae4-39c7-4e76-87a5-de05a365ff98",
              code: "PERM_RECEIPT_UPDATE",
              name: "PERM_RECEIPT_UPDATE",
              sequence: 21,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "dd20d7d3-4062-46a8-b2d0-78215156ada5",
          code: "PERM_SET_RECEIPT_READ",
          sequence: 20,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "0c8fdfda-59b1-4757-9b2b-62de1f22f016",
              code: "PERM_RECEIPT_READ",
              name: "PERM_RECEIPT_READ",
              sequence: 22,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "0498c0ef-3c45-43cf-a106-7c2fa5139a72",
          code: "PERM_SET_TIME_BILL_CREATE",
          sequence: 21,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "13a7cace-1f7d-42a0-bf83-b4bd5b52de85",
              code: "PERM_COMPANY_TIME_BILL_CREATE",
              name: "PERM_COMPANY_TIME_BILL_CREATE",
              sequence: 23,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "664d02ed-8459-4599-9553-93fd768a14db",
          code: "PERM_SET_TIME_BILL_UPDATE",
          sequence: 22,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "2e2aba08-b582-4e68-a641-5d53414ab447",
              code: "PERM_COMPANY_TIME_BILL_UPDATE",
              name: "PERM_COMPANY_TIME_BILL_UPDATE",
              sequence: 24,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "fbff9ca0-0930-425c-9db9-0ee12479c420",
          code: "PERM_SET_TIME_BILL_READ",
          sequence: 23,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "7e939835-355c-466a-b299-de76363c850e",
              code: "PERM_COMPANY_TIME_BILL_READ",
              name: "PERM_COMPANY_TIME_BILL_READ",
              sequence: 25,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "b479d9cd-b51f-415a-a55f-7e47c3d0cc6e",
          code: "PERM_SET_COMPANY_INVOICING_CREATE",
          sequence: 24,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "0943fc0f-080d-4135-902a-0181a0509a09",
              code: "PERM_COMPANY_INVOICING_CREATE",
              name: "PERM_COMPANY_INVOICING_CREATE",
              sequence: 26,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "9d742247-8927-4c6a-b814-8f9c455c1906",
          code: "PERM_SET_COMPANY_INVOICING_UPDATE",
          sequence: 25,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "83d911be-2745-4088-93fa-82538cad3c4c",
              code: "PERM_COMPANY_INVOICING_UPDATE",
              name: "PERM_COMPANY_INVOICING_UPDATE",
              sequence: 27,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "b9413f9a-b673-41dd-ac42-76c5678d4e0e",
          code: "PERM_SET_COMPANY_INVOICING_READ",
          sequence: 26,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "959b5eec-dfb1-4293-956d-35dcc84fbe1e",
              code: "PERM_COMPANY_INVOICING_READ",
              name: "PERM_COMPANY_INVOICING_READ",
              sequence: 28,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "c9dfc2fc-678b-407c-a5a1-8dc7d57d957f",
          code: "PERM_SET_EMAIL_GEN_CREATE",
          sequence: 27,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "de4b18da-c7ca-4718-9b9e-4095e6b05389",
              code: "PERM_EMAIL_GEN_CREATE",
              name: "PERM_EMAIL_GEN_CREATE",
              sequence: 29,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "08847406-8d30-4234-8380-391e5d8d819d",
          code: "PERM_SET_EMAIL_GEN_UPDATE",
          sequence: 28,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "082b1341-9622-4caa-8846-fc5a1d31b40c",
              code: "PERM_EMAIL_GEN_UPDATE",
              name: "PERM_EMAIL_GEN_UPDATE",
              sequence: 30,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "6021b6c7-db39-4f34-8385-2e6852b7bb2b",
          code: "PERM_SET_EMAIL_GEN_READ",
          sequence: 29,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "998891fd-ce4d-4fe5-86a0-76f299df4fa7",
              code: "PERM_EMAIL_GEN_READ",
              name: "PERM_EMAIL_GEN_READ",
              sequence: 31,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "9b425dd3-5722-4266-9049-91c7980ae2e4",
          code: "PERM_SET_PROCESSED_USER_TASK_READ",
          sequence: 30,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "486ce335-b2fe-4e3d-88c2-93a799ad2c20",
              code: "PERM_PROCESSED_USER_TASK_READ",
              name: "PERM_PROCESSED_USER_TASK_READ",
              sequence: 32,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "b2b311b9-a61c-4414-9003-90e50f04d32d",
          code: "PERM_SET_COMPANY_READ",
          sequence: 31,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "3d63d2b8-75db-4382-90e1-230bac14dac8",
              code: "PERM_COMPANY_READ",
              name: "PERM_COMPANY_READ",
              sequence: 33,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "5db6bf7a-72e0-4f17-8221-f4c3a7c9c92d",
          code: "PERM_SET_INDIVIDUAL_READ",
          sequence: 32,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "cba6d9fd-be19-4890-a3fc-7791049bb956",
              code: "PERM_INDIVIDUAL_READ",
              name: "PERM_INDIVIDUAL_READ",
              sequence: 34,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "f93f1793-c88d-42fa-8e0f-16f264273272",
          code: "PERM_SET_AGENT_READ",
          sequence: 33,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "1d83fbf4-edb5-4922-a9dc-5fdc85e3400a",
              code: "PERM_AGENT_READ",
              name: "PERM_AGENT_READ",
              sequence: 35,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "3b66d5ac-44e6-4123-94bc-393c3e17444c",
          code: "PERM_SET_GEN_DOC_TEMP_CREATE",
          sequence: 34,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "85865e76-01a6-4f48-ae7b-1b82891848bc",
              code: "PERM_GEN_DOC_TEMP_CREATE",
              name: "PERM_GEN_DOC_TEMP_CREATE",
              sequence: 36,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "5119ed76-4b86-4532-b952-3fc8d0b7f223",
          code: "PERM_SET_GEN_DOC_TEMP_UPDATE",
          sequence: 35,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "5457e552-fcca-497d-bc0b-0890fceceb1d",
              code: "PERM_GEN_DOC_TEMP_UPDATE",
              name: "PERM_GEN_DOC_TEMP_UPDATE",
              sequence: 37,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "ee3e2bee-8503-439b-82a0-79cdd33ef8f8",
          code: "PERM_SET_GEN_DOC_TEMP_READ",
          sequence: 36,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "1ea7c476-5bd8-42d2-aac6-d4e13f6d9ea6",
              code: "PERM_GEN_DOC_TEMP_READ",
              name: "PERM_GEN_DOC_TEMP_READ",
              sequence: 38,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "a0e3b1e5-9952-4d96-899d-9e0033b2df34",
          code: "PERM_SET_DOC_UPLOAD_CREATE",
          sequence: 37,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "4992c5b5-b2d3-4cc2-b42f-7cafee97acbb",
              code: "PERM_DOC_UPLOAD_CREATE",
              name: "PERM_DOC_UPLOAD_CREATE",
              sequence: 39,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "d6660c95-8e06-4526-8647-a69b98ae1e5e",
          code: "PERM_SET_DOC_UPLOAD_UPDATE",
          sequence: 38,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "70b0bf22-692a-44a1-b52c-134d70ea2bd3",
              code: "PERM_DOC_UPLOAD_UPDATE",
              name: "PERM_DOC_UPLOAD_UPDATE",
              sequence: 40,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "468380db-5df2-40db-9393-30d891674cca",
          code: "PERM_SET_DOC_UPLOAD_READ",
          sequence: 39,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "3fca4367-d2ae-4e7d-845b-016fdefbfaaa",
              code: "PERM_DOC_UPLOAD_READ",
              name: "PERM_DOC_UPLOAD_READ",
              sequence: 41,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "95774781-bdb4-4b15-9db4-a66460c93771",
          code: "PERM_SET_JURISDICTION_CREATE",
          sequence: 40,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "edb837aa-a072-4723-a277-f92882e971a3",
              code: "PERM_JURISDICTION_CREATE",
              name: "PERM_JURISDICTION_CREATE",
              sequence: 42,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "c25efdad-9553-418c-9734-6f6f07d2f44f",
          code: "PERM_SET_JURISDICTION_UPDATE",
          sequence: 41,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "b0613717-eebe-4e4a-ac32-1aa4aedd912a",
              code: "PERM_JURISDICTION_UPDATE",
              name: "PERM_JURISDICTION_UPDATE",
              sequence: 43,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "562ca750-4888-487e-a42a-e8a813845e1a",
          code: "PERM_SET_JURISDICTION_READ",
          sequence: 42,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "d3726e18-f99b-4a1c-a4a7-502853c706e8",
              code: "PERM_JURISDICTION_READ",
              name: "PERM_JURISDICTION_READ",
              sequence: 44,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "a3ab1a7c-f6bb-4a54-9e7e-b6371dabfb2b",
          code: "PERM_SET_INVOICING_CREATE",
          sequence: 43,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "d2600f4d-c2f8-4259-821f-fa985f55e262",
              code: "PERM_INVOICING_CREATE",
              name: "PERM_INVOICING_CREATE",
              sequence: 45,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "8a0463cf-cf62-46a1-8e4f-c37e95616d1a",
          code: "PERM_SET_INVOICING_UPDATE",
          sequence: 44,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "1a6f0cfd-ea7a-4b0e-acd5-3e46d8554557",
              code: "PERM_INVOICING_UPDATE",
              name: "PERM_INVOICING_UPDATE",
              sequence: 46,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "d2f8a225-4007-41da-89bf-217635fa4407",
          code: "PERM_SET_INVOICING_READ",
          sequence: 45,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "6c24c521-75e7-4bce-80bc-50f5df1e2592",
              code: "PERM_INVOICING_READ",
              name: "PERM_INVOICING_READ",
              sequence: 47,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "c29d4623-17a6-46f2-b366-e4b476500cd6",
          code: "PERM_SET_MASTER_INFO_CREATE",
          sequence: 46,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "d780c995-b33c-42a1-8746-51fb75ac0384",
              code: "PERM_MASTER_INFO_CREATE",
              name: "PERM_MASTER_INFO_CREATE",
              sequence: 48,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "680626e4-7f0a-49f4-88ef-2df6d0f1e986",
          code: "PERM_SET_MASTER_INFO_UPDATE",
          sequence: 47,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "8b6e56cd-5e61-4bc8-b39a-c44a030a73c7",
              code: "PERM_MASTER_INFO_UPDATE",
              name: "PERM_MASTER_INFO_UPDATE",
              sequence: 49,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "1614a78e-6b69-41ed-8ea8-279295a6f289",
          code: "PERM_SET_MASTER_INFO_READ",
          sequence: 48,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "781d8fbb-01ba-4c9f-8290-6fd52d7bcb6a",
              code: "PERM_MASTER_INFO_READ",
              name: "PERM_MASTER_INFO_READ",
              sequence: 50,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "d624b219-244e-45df-92ee-c34f86d99e7f",
          code: "PERM_SET_EMAIL_TEMPLATE_CREATE",
          sequence: 49,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "5a05d096-5ef4-4526-a1d2-d840734a476c",
              code: "PERM_EMAIL_TEMPLATE_CREATE",
              name: "PERM_EMAIL_TEMPLATE_CREATE",
              sequence: 51,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "abe24eaa-0d1c-4492-a537-0539c3e04f29",
          code: "PERM_SET_EMAIL_TEMPLATE_UPDATE",
          sequence: 50,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "ea33f7ef-e13e-4379-b7d9-e7b8c29d4994",
              code: "PERM_EMAIL_TEMPLATE_UPDATE",
              name: "PERM_EMAIL_TEMPLATE_UPDATE",
              sequence: 52,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "7bd17f9c-e581-4af7-8882-f24d26c9b8f4",
          code: "PERM_SET_EMAIL_TEMPLATE_READ",
          sequence: 51,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "4c9055a0-a9bd-405c-b5af-ba7bca15ef8f",
              code: "PERM_EMAIL_TEMPLATE_READ",
              name: "PERM_EMAIL_TEMPLATE_READ",
              sequence: 53,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "d6b52c92-b15c-4673-b867-0a8f991d2d38",
          code: "PERM_SET_USER_TASK_CAR_SETUP",
          sequence: 52,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "eef089ab-2774-40e0-bb49-8fcc6bd907bf",
              code: "PERM_USER_TASK_CAR_SETUP",
              name: "PERM_USER_TASK_CAR_SETUP",
              sequence: 54,
              description: null,
              type: "ADMIN",
            },
          ],
        },
        {
          permissionSetId: "e4693212-c1f0-456a-8b85-2d235c464fad",
          code: "PERM_SET_SYSTEM_SETTING_SETUP",
          sequence: 53,
          type: "ADMIN",
          permissions: [
            {
              permissionId: "957e0832-a846-4e39-abdd-d4da6cc78a31",
              code: "PERM_SYSTEM_SETTING_SETUP",
              name: "PERM_SYSTEM_SETTING_SETUP",
              sequence: 55,
              description: null,
              type: "ADMIN",
            },
          ],
        },
      ],
    },
  ],
  loginFailCount: 0,
  isForceChangePassword: false,
  userTokens: [
    {
      userTokenId: "e68d1918-1a44-4bda-9c4d-badc725d5168",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NjM0MzAxOTE0OCwiaXNzIjoiMTIxYmJmYmItZGIwYy00NTM2LWI5MTEtZjcyMjIyMGM5M2E4IiwiZGV2aWNlSWQiOiIifQ.lDDBrvfl1J9C3PWU0mDfH-DRkLzhSbL28bfwH00Lf8bmWg1U2L6MUpN31JSp3f4ApokNhH6F-wDS9rUyf1L8rQ",
      createdDate: "2022-10-21T09:03:39.149+00:00",
      lastAccessDate: "2022-10-21T09:05:00.030+00:00",
      type: "NORMAL",
      lastAccessIp: "0:0:0:0:0:0:0:1",
    },
    {
      userTokenId: "27c56401-48d5-488f-be34-a8575aa676d3",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NjM1OTcwMjMyMiwiaXNzIjoiMmIxY2FhZGEtNmRkZC00NWU3LThjMzYtM2EwOTdmZjJjNWM2IiwiZGV2aWNlSWQiOiIifQ.2ITfG6g6TtC2N8l3P4DcoF3j8yBKLbKHj0jzxP2EqwpwE7HmqPoeOiry5X2kyqBVjEHASjvifFpcsulnhz-4aQ",
      createdDate: "2022-10-21T13:41:45.882+00:00",
      lastAccessDate: "2022-10-24T17:17:51.340+00:00",
      type: "NORMAL",
      lastAccessIp: "0:0:0:0:0:0:0:1",
    },
    {
      userTokenId: "69b1dd83-3a7c-40dd-bf5a-91971c49a530",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NjY3MjgxMjA4MSwiaXNzIjoiMDE4ODEwOTEtNjYzYS00ODE5LWE3YmUtMDMwYzgxODUxYTM5IiwiZGV2aWNlSWQiOiIifQ.uMI9fE1mobV03yN3TEJdodOjzUIouMaND6TLRSS0pwR2zb4CuLs0ug2dShG59-5g-Exn-uu8Wz9q1X0DIehX3g",
      createdDate: "2022-10-25T04:40:12.095+00:00",
      lastAccessDate: "2022-10-26T15:43:11.708+00:00",
      type: "NORMAL",
      lastAccessIp: "0:0:0:0:0:0:0:1",
    },
    {
      userTokenId: "86910bdf-5823-4f50-b921-39c7ce6e2dc3",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NjI3NjE2NTYyNCwiaXNzIjoiZmU2MGY2ZGQtZWUwYS00YjFkLWE0YTQtNzI4ZmI0YzZiZDViIiwiZGV2aWNlSWQiOiIifQ.wl7CcFyQKhJp62H2fXoNyDloU3oNfPyhHDuKPz7pUzva0AmFViO5Vdjmo0gMDua-PLOvKH4ZphOSsGIHrBXbLw",
      createdDate: "2022-10-20T14:29:26.714+00:00",
      lastAccessDate: "2022-10-21T07:17:32.670+00:00",
      type: "NORMAL",
      lastAccessIp: "127.0.0.1",
    },
    {
      userTokenId: "43a634a7-98b9-402d-8496-0d72574ff176",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2Njg1NzEzNjAzMywiaXNzIjoiZTQ3M2U3NzYtMzJmYy00MmQ5LTk5MGQtMzFhODFmMmI0ZmVkIiwiZGV2aWNlSWQiOiIifQ.RVDtvI1fVD_TpGZBoSKegHcRKrx0FhsVR8Ntm0PxPCKas2nZIqAnyLv4OnTubxtXdk6-LmyfLt8ShJGNL0mCfA",
      createdDate: "2022-10-27T07:52:16.045+00:00",
      lastAccessDate: "2022-10-31T06:21:34.822+00:00",
      type: "NORMAL",
      lastAccessIp: "0:0:0:0:0:0:0:1",
    },
    {
      userTokenId: "09fef1f6-aa18-41a5-ac68-7776bea4ebe3",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2Njg1NzkzMTUyMiwiaXNzIjoiYjA0Mzg3MjMtMTlhNi00NDc5LWEyYTYtN2E0YTQxODJlNTRmIiwiZGV2aWNlSWQiOiIifQ.YgFEqTTGt2_Wl4UGuiB6ZhVaeDVSDR6qzWCX0DxKE5VJw6crK9qdd-A0yBjfUW8pcFDxF6As30lG4W8Y70cHBQ",
      createdDate: "2022-10-27T08:05:31.523+00:00",
      lastAccessDate: "2022-10-31T06:21:53.079+00:00",
      type: "NORMAL",
      lastAccessIp: "0:0:0:0:0:0:0:1",
    },
    {
      userTokenId: "905f5d66-9982-4f00-8f63-e7f8f3c27666",
      userId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
      token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NzQ1NzU2Nzg0OCwiaXNzIjoiMWM2OTA1MDktNzVmZC00MzUxLTk2MjEtMTgyZTQyNmFiMWRmIiwiZGV2aWNlSWQiOiIifQ.ozdHPBjSdv7yEDwFKh8wrZCYZ_cv418GqLOZLaSyk2T8BeetqblTvYW6VhGRJo5pBoio5OD-pl2Tmm7Wh4DcDw",
      createdDate: "2022-11-03T06:39:32.773+00:00",
      lastAccessDate: "2022-11-03T13:28:35.310+00:00",
      type: "NORMAL",
      lastAccessIp: "0:0:0:0:0:0:0:1",
    },
  ],
  lastLoginTime: null,
  userPasswordType: "USER",
  fullName: "Super Admin",
  enabled: true,
  credentialsNonExpired: true,
  accountNonExpired: true,
  accountNonLocked: true,
  authorities: [
    {
      authority: "PERM_RECEIPT_UPDATE",
    },
    {
      authority: "PERM_SET_DOC_UPLOAD_CREATE",
    },
    {
      authority: "PERM_COMPANY_INVOICING_READ",
    },
    {
      authority: "PERM_COMPANY_READ",
    },
    {
      authority: "PERM_SET_DOC_UPLOAD_READ",
    },
    {
      authority: "PERM_SET_EMAIL_GEN_UPDATE",
    },
    {
      authority: "PERM_COMPANY_INVOICING_UPDATE",
    },
    {
      authority: "PERM_GEN_DOC_TEMP_CREATE",
    },
    {
      authority: "PERM_SET_ROLE_READ",
    },
    {
      authority: "PERM_SET_COMPANY_INVOICING_UPDATE",
    },
    {
      authority: "PERM_EMAIL_GEN_READ",
    },
    {
      authority: "PERM_COMPANY_TIME_BILL_UPDATE",
    },
    {
      authority: "PERM_SET_USER_CREATE",
    },
    {
      authority: "PERM_COMPANY_TIME_BILL_READ",
    },
    {
      authority: "PERM_INVOICING_READ",
    },
    {
      authority: "PERM_SET_AGENT_READ",
    },
    {
      authority: "PERM_WORKFLOW_FORM_UPDATE",
    },
    {
      authority: "PERM_CASE_INFO_READ",
    },
    {
      authority: "PERM_PROCESS_WORKFLOW_UPDATE",
    },
    {
      authority: "PERM_COMPANY_TIME_BILL_CREATE",
    },
    {
      authority: "PERM_EMAIL_GEN_UPDATE",
    },
    {
      authority: "PERM_ROLE_READ",
    },
    {
      authority: "PERM_SET_PROCESSED_USER_TASK_READ",
    },
    {
      authority: "PERM_PROCESSED_USER_TASK_READ",
    },
    {
      authority: "PERM_SET_EMAIL_TEMPLATE_CREATE",
    },
    {
      authority: "PERM_SET_COMPANY_INVOICING_CREATE",
    },
    {
      authority: "PERM_SET_ADMIN_LOGIN",
    },
    {
      authority: "PERM_RECEIPT_CREATE",
    },
    {
      authority: "PERM_USER_READ",
    },
    {
      authority: "PERM_PROCESS_WORKFLOW_POST",
    },
    {
      authority: "PERM_SET_JURISDICTION_CREATE",
    },
    {
      authority: "PERM_RECEIPT_READ",
    },
    {
      authority: "PERM_MASTER_INFO_READ",
    },
    {
      authority: "PERM_SET_JURISDICTION_READ",
    },
    {
      authority: "PERM_SET_COMPANY_READ",
    },
    {
      authority: "PERM_PROCESS_WORKFLOW_READ",
    },
    {
      authority: "PERM_MASTER_INFO_CREATE",
    },
    {
      authority: "PERM_SET_PROCESS_WORKFLOW_DISCARD",
    },
    {
      authority: "PERM_SET_CASE_INFO_READ",
    },
    {
      authority: "PERM_ADMIN_LOGIN",
    },
    {
      authority: "PERM_INDIVIDUAL_READ",
    },
    {
      authority: "PERM_SET_GEN_DOC_TEMP_UPDATE",
    },
    {
      authority: "PERM_JURISDICTION_UPDATE",
    },
    {
      authority: "PERM_SYSTEM_SETTING_SETUP",
    },
    {
      authority: "PERM_SET_USER_UPDATE",
    },
    {
      authority: "PERM_SET_SYSTEM_SETTING_SETUP",
    },
    {
      authority: "PERM_SET_EMAIL_GEN_READ",
    },
    {
      authority: "PERM_ROLE_CREATE",
    },
    {
      authority: "PERM_SET_RECEIPT_READ",
    },
    {
      authority: "PERM_SET_PROCESS_WORKFLOW_CREATE",
    },
    {
      authority: "PERM_SET_CASE_INFO_CREATE",
    },
    {
      authority: "PERM_USER_UPDATE",
    },
    {
      authority: "PERM_SET_ROLE_CREATE",
    },
    {
      authority: "PERM_SET_TIME_BILL_CREATE",
    },
    {
      authority: "PERM_GEN_DOC_TEMP_READ",
    },
    {
      authority: "PERM_SET_INVOICING_READ",
    },
    {
      authority: "PERM_AGENT_READ",
    },
    {
      authority: "PERM_SET_PROCESS_WORKFLOW_POST",
    },
    {
      authority: "PERM_EMAIL_TEMPLATE_CREATE",
    },
    {
      authority: "PERM_EMAIL_TEMPLATE_READ",
    },
    {
      authority: "PERM_SET_USER_TASK_CAR_SETUP",
    },
    {
      authority: "PERM_SET_MASTER_INFO_UPDATE",
    },
    {
      authority: "PERM_SET_USER_READ",
    },
    {
      authority: "PERM_SET_RECEIPT_UPDATE",
    },
    {
      authority: "PERM_JURISDICTION_READ",
    },
    {
      authority: "PERM_INVOICING_UPDATE",
    },
    {
      authority: "PERM_SET_WORKFLOW_FORM_UPDATE",
    },
    {
      authority: "PERM_SET_GEN_DOC_TEMP_CREATE",
    },
    {
      authority: "PERM_SET_INVOICING_CREATE",
    },
    {
      authority: "PERM_SET_RECEIPT_CREATE",
    },
    {
      authority: "PERM_PROCESS_WORKFLOW_CREATE",
    },
    {
      authority: "PERM_USER_CHANGE_SELF_PASSWORD",
    },
    {
      authority: "PERM_SET_TIME_BILL_READ",
    },
    {
      authority: "PERM_EMAIL_GEN_CREATE",
    },
    {
      authority: "PERM_CASE_INFO_CREATE",
    },
    {
      authority: "PERM_SET_PROCESS_WORKFLOW_READ",
    },
    {
      authority: "PERM_DOC_UPLOAD_UPDATE",
    },
    {
      authority: "PERM_SET_EMAIL_TEMPLATE_UPDATE",
    },
    {
      authority: "PERM_SET_CASE_INFO_UPDATE",
    },
    {
      authority: "PERM_USER_SELF_READ",
    },
    {
      authority: "PERM_SET_INDIVIDUAL_READ",
    },
    {
      authority: "PERM_INVOICING_CREATE",
    },
    {
      authority: "PERM_SET_INVOICING_UPDATE",
    },
    {
      authority: "PERM_DOC_UPLOAD_CREATE",
    },
    {
      authority: "PERM_SET_WORKFLOW_FORM_READ",
    },
    {
      authority: "PERM_SET_EMAIL_GEN_CREATE",
    },
    {
      authority: "PERM_SET_GEN_DOC_TEMP_READ",
    },
    {
      authority: "PERM_SET_MASTER_INFO_CREATE",
    },
    {
      authority: "PERM_SET_DOC_UPLOAD_UPDATE",
    },
    {
      authority: "PERM_JURISDICTION_CREATE",
    },
    {
      authority: "PERM_SET_PROCESS_WORKFLOW_UPDATE",
    },
    {
      authority: "PERM_SET_ROLE_UPDATE",
    },
    {
      authority: "PERM_PROCESS_WORKFLOW_DISCARD",
    },
    {
      authority: "PERM_WORKFLOW_FORM_READ",
    },
    {
      authority: "PERM_SET_MASTER_INFO_READ",
    },
    {
      authority: "PERM_CASE_INFO_UPDATE",
    },
    {
      authority: "PERM_WORKFLOW_FORM_CREATE",
    },
    {
      authority: "PERM_ROLE_UPDATE",
    },
    {
      authority: "PERM_SET_COMPANY_INVOICING_READ",
    },
    {
      authority: "PERM_USER_TASK_CAR_SETUP",
    },
    {
      authority: "PERM_SET_EMAIL_TEMPLATE_READ",
    },
    {
      authority: "PERM_DOC_UPLOAD_READ",
    },
    {
      authority: "PERM_SET_JURISDICTION_UPDATE",
    },
    {
      authority: "PERM_EMAIL_TEMPLATE_UPDATE",
    },
    {
      authority: "PERM_SET_WORKFLOW_FORM_CREATE",
    },
    {
      authority: "PERM_USER_CREATE",
    },
    {
      authority: "PERM_GEN_DOC_TEMP_UPDATE",
    },
    {
      authority: "PERM_MASTER_INFO_UPDATE",
    },
    {
      authority: "PERM_COMPANY_INVOICING_CREATE",
    },
    {
      authority: "PERM_SET_TIME_BILL_UPDATE",
    },
  ],
}


export const userTwo: any = {
  "createdUserId": null,
  "createdUserUsername": null,
  "createdUserFullname": null,
  "createdUserEmail": null,
  "createdDate": "2022-10-14T01:59:55.759+00:00",
  "updatedUserId": "433e1f06-37a7-460f-a7dc-6b810f7f2194",
  "updatedUserUsername": null,
  "updatedUserFullname": null,
  "updatedUserEmail": null,
  "updatedDate": "2022-10-14T06:17:15.250+00:00",
  "version": 2,
  "userId": "7957c3e5-66eb-426f-ac3d-9d1a054c7302",
  "username": "superadmin2",
  "userPassword": "272790ee4f85484e17796b6b599c0f76915a96b4f8b6bce87ea504b661a18c3839061ec87a0b4cfd",
  "firstName": "Super",
  "lastName": "Admin2",
  "userEmail": "superadmin@cityline.com.hk",
  "status": "ENABLED",
  "roles": [
    {
      "createdUserId": null,
      "createdUserUsername": null,
      "createdUserFullname": null,
      "createdUserEmail": null,
      "createdDate": "2022-10-14T01:59:55.636+00:00",
      "updatedUserId": null,
      "updatedUserUsername": null,
      "updatedUserFullname": null,
      "updatedUserEmail": null,
      "updatedDate": "2022-10-19T07:57:57.444+00:00",
      "version": 10,
      "roleId": "1ad35798-3fd9-41cd-a145-5c39c85e93d9",
      "roleCode": "SUPER_ADMIN",
      "type": "ADMIN",
      "roleName": {
        "i18nStringMapId": "eb7c0ec9-67e4-4f5c-a339-a367d2660e0c",
        "i18nStrings": [
          {
            "i18nStringId": "6b7593e7-2d9c-4f0a-aa7d-3f80c179aa09",
            "locale": "en",
            "value": "Super Admin"
          },
          {
            "i18nStringId": "e37896d0-18ec-42ee-b86a-b03749ce632c",
            "locale": "zh_TW",
            "value": "Super Admin"
          },
          {
            "i18nStringId": "40b54525-b260-4c0c-91a4-b29f50bc8783",
            "locale": "zh_CN",
            "value": "Super Admin"
          }
        ]
      },
      "remarks": null,
      "permissionSets": [
        {
          "permissionSetId": "8d5d04dd-8e14-4ca8-8af6-4f4854aff580",
          "code": "PERM_SET_ADMIN_LOGIN",
          "sequence": 0,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "e09e65f3-5d1a-4364-bec2-591d136c3f93",
              "code": "PERM_ADMIN_LOGIN",
              "name": "PERM_ADMIN_LOGIN",
              "sequence": 0,
              "description": null,
              "type": "ADMIN"
            },
            {
              "permissionId": "a5f08f8e-e5de-4a18-8092-4f9efbe855b7",
              "code": "PERM_USER_CHANGE_SELF_PASSWORD",
              "name": "PERM_USER_CHANGE_SELF_PASSWORD",
              "sequence": 1,
              "description": null,
              "type": "ADMIN"
            },
            {
              "permissionId": "f79b6c1c-e90e-4036-ac84-96746dc20ae9",
              "code": "PERM_USER_SELF_READ",
              "name": "PERM_USER_SELF_READ",
              "sequence": 2,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "da58bfae-d6cc-4c45-b142-71a2af92c33f",
          "code": "PERM_SET_ROLE_CREATE",
          "sequence": 1,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "d1abcf68-15d2-4c3f-9364-fcdbd83ec26c",
              "code": "PERM_ROLE_CREATE",
              "name": "PERM_ROLE_CREATE",
              "sequence": 3,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "c9128daf-55b7-4a48-9861-49aa3e85a0b9",
          "code": "PERM_SET_ROLE_READ",
          "sequence": 2,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "435a188e-eaaf-4ca5-b606-73851eabcf91",
              "code": "PERM_ROLE_READ",
              "name": "PERM_ROLE_READ",
              "sequence": 4,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "4ab37818-c8cf-4fe2-b1b9-216c321425b5",
          "code": "PERM_SET_ROLE_UPDATE",
          "sequence": 3,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "229af7e8-1117-4425-a2a7-cff1905fbaa5",
              "code": "PERM_ROLE_UPDATE",
              "name": "PERM_ROLE_UPDATE",
              "sequence": 5,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "1b24b682-2480-4b8c-afdf-f511fee54e03",
          "code": "PERM_SET_GROUP_CREATE",
          "sequence": 4,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "720e7166-0838-4520-bec8-076963206523",
              "code": "PERM_GROUP_CREATE",
              "name": "PERM_GROUP_CREATE",
              "sequence": 6,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "e2a71ecd-17e6-45ff-8d50-be9da8a6c0b3",
          "code": "PERM_SET_GROUP_UPDATE",
          "sequence": 5,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "47e3c14a-9a78-45b6-95f3-c2f4078f781e",
              "code": "PERM_GROUP_UPDATE",
              "name": "PERM_GROUP_UPDATE",
              "sequence": 7,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "35682987-7ca5-4c8d-9cbb-b9064cd95352",
          "code": "PERM_SET_GROUP_READ",
          "sequence": 6,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "ef5b5df9-d3b9-48f9-99c9-edf1d4ff72c9",
              "code": "PERM_GROUP_READ",
              "name": "PERM_GROUP_READ",
              "sequence": 8,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "2f623c85-5954-4114-8870-04d57116871f",
          "code": "PERM_SET_USER_CREATE",
          "sequence": 7,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "0b41e824-17df-422b-9ed5-1d9b578f8724",
              "code": "PERM_USER_CREATE",
              "name": "PERM_USER_CREATE",
              "sequence": 9,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "63d63d91-8f07-4492-8894-e471726677f4",
          "code": "PERM_SET_USER_UPDATE",
          "sequence": 8,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "7e2721ed-991c-4a78-bbd7-4c067b13249f",
              "code": "PERM_USER_UPDATE",
              "name": "PERM_USER_UPDATE",
              "sequence": 10,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "c5639aa6-d7ad-42af-a070-4ab348ca6db2",
          "code": "PERM_SET_USER_READ",
          "sequence": 9,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "501457a5-d950-4129-a62c-28cd61a7467a",
              "code": "PERM_USER_READ",
              "name": "PERM_USER_READ",
              "sequence": 11,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "9d028765-f915-4970-98e8-42c1cc8e8376",
          "code": "PERM_SET_WORKFLOW_FORM_CREATE",
          "sequence": 10,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "fada6d88-0e43-43c0-8302-2c311c8e21f1",
              "code": "PERM_WORKFLOW_FORM_CREATE",
              "name": "PERM_WORKFLOW_FORM_CREATE",
              "sequence": 12,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "cf300b69-6352-438e-8852-6f6d08bbc208",
          "code": "PERM_SET_WORKFLOW_FORM_UPDATE",
          "sequence": 11,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "7caa9ad8-7120-46a7-b364-b61a2bfa1431",
              "code": "PERM_WORKFLOW_FORM_UPDATE",
              "name": "PERM_WORKFLOW_FORM_UPDATE",
              "sequence": 13,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "f79e59b3-a107-469b-9a1e-33dd2662dced",
          "code": "PERM_SET_WORKFLOW_FORM_READ",
          "sequence": 12,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "4eb85cc4-13bc-4394-bf3f-e6494c82ca4e",
              "code": "PERM_WORKFLOW_FORM_READ",
              "name": "PERM_WORKFLOW_FORM_READ",
              "sequence": 14,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "e5a4b344-44a5-41bc-bf22-b040ab52598f",
          "code": "PERM_SET_CASE_INFO_CREATE",
          "sequence": 13,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "d2e90c33-0402-40ac-99f4-25bac5dadbff",
              "code": "PERM_CASE_INFO_CREATE",
              "name": "PERM_CASE_INFO_CREATE",
              "sequence": 15,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "c37914f2-e748-44b6-b00e-e156e2c8c2ca",
          "code": "PERM_SET_CASE_INFO_UPDATE",
          "sequence": 14,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "88155546-492d-49c2-a93c-8c7934094278",
              "code": "PERM_CASE_INFO_UPDATE",
              "name": "PERM_CASE_INFO_UPDATE",
              "sequence": 16,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "eefb903b-02b3-4063-b5d0-f058e61250d3",
          "code": "PERM_SET_CASE_INFO_READ",
          "sequence": 15,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "6017680d-fd35-4ae2-aed0-83c95c7c4f10",
              "code": "PERM_CASE_INFO_READ",
              "name": "PERM_CASE_INFO_READ",
              "sequence": 17,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "5a62ad21-0252-4fbc-8f54-f6d8d653a350",
          "code": "PERM_SET_PROCESS_WORKFLOW_CREATE",
          "sequence": 16,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "422947e6-4cee-4b77-a2be-eef3aefffa01",
              "code": "PERM_PROCESS_WORKFLOW_CREATE",
              "name": "PERM_PROCESS_WORKFLOW_CREATE",
              "sequence": 18,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "b63a2ba8-4b6c-458f-becb-b9de10aa2201",
          "code": "PERM_SET_PROCESS_WORKFLOW_UPDATE",
          "sequence": 17,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "e86d0130-03fe-4c0e-8240-1809b3724d70",
              "code": "PERM_PROCESS_WORKFLOW_UPDATE",
              "name": "PERM_PROCESS_WORKFLOW_UPDATE",
              "sequence": 19,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "ba037298-9887-4e2c-9471-b0095679b8f5",
          "code": "PERM_SET_PROCESS_WORKFLOW_READ",
          "sequence": 18,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "dc8cbaee-dd04-4bbc-9d04-53cb85d90c94",
              "code": "PERM_PROCESS_WORKFLOW_READ",
              "name": "PERM_PROCESS_WORKFLOW_READ",
              "sequence": 20,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "0f965da0-395a-437a-9f34-a8f11ecacb6e",
          "code": "PERM_SET_PROCESS_WORKFLOW_POST",
          "sequence": 19,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "e71c7b7e-f79b-4c3e-a411-863070843e39",
              "code": "PERM_PROCESS_WORKFLOW_POST",
              "name": "PERM_PROCESS_WORKFLOW_POST",
              "sequence": 21,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "5ff0ecb5-044d-4a44-8e9b-a393e1e189f5",
          "code": "PERM_SET_PROCESS_WORKFLOW_DISCARD",
          "sequence": 20,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "1b46e8bf-a1c0-4c04-b814-164b61ba107c",
              "code": "PERM_PROCESS_WORKFLOW_DISCARD",
              "name": "PERM_PROCESS_WORKFLOW_DISCARD",
              "sequence": 22,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "6f5a0f8a-4ac9-4a21-ab19-af27cbf329c3",
          "code": "PERM_SET_RECEIPT_CREATE",
          "sequence": 21,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "1fb49e46-032c-4aa5-99e4-536dfebbe0c4",
              "code": "PERM_RECEIPT_CREATE",
              "name": "PERM_RECEIPT_CREATE",
              "sequence": 23,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "f0c32051-22ab-42eb-bfa5-af6d34a26759",
          "code": "PERM_SET_RECEIPT_UPDATE",
          "sequence": 22,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "829359f6-d47d-4531-a963-8daf49174b6e",
              "code": "PERM_RECEIPT_UPDATE",
              "name": "PERM_RECEIPT_UPDATE",
              "sequence": 24,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "e17940e9-15e1-4ed9-97b5-df3471297460",
          "code": "PERM_SET_RECEIPT_READ",
          "sequence": 23,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "4011cb9a-9a6a-4a6f-b89d-4d5d6d5cc6cd",
              "code": "PERM_RECEIPT_READ",
              "name": "PERM_RECEIPT_READ",
              "sequence": 25,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "ed662be8-6138-446f-9b2c-a4bdbdcc4e19",
          "code": "PERM_SET_PROCESSED_USER_TASK_READ",
          "sequence": 24,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "4cbb00ab-0018-4ae8-88a1-a71b69c08ec5",
              "code": "PERM_PROCESSED_USER_TASK_READ",
              "name": "PERM_PROCESSED_USER_TASK_READ",
              "sequence": 26,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "80f87243-dc87-4d12-9c97-05c9e10b30a4",
          "code": "PERM_SET_COMPANY_READ",
          "sequence": 25,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "6eaa15cd-78a0-405b-9aa5-b15822136cb9",
              "code": "PERM_COMPANY_READ",
              "name": "PERM_COMPANY_READ",
              "sequence": 27,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "3f7fd134-cd61-446f-9e4b-e43eb8ed9f0a",
          "code": "PERM_SET_INDIVIDUAL_READ",
          "sequence": 26,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "19332c92-af0f-4e09-85f6-bf17cbb7a2a8",
              "code": "PERM_INDIVIDUAL_READ",
              "name": "PERM_INDIVIDUAL_READ",
              "sequence": 28,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "b19aa9e9-dcdb-410e-9fc8-5f92badc7c03",
          "code": "PERM_SET_AGENT_READ",
          "sequence": 27,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "74f6225d-2aa5-48b4-bc4f-4f894a53bad3",
              "code": "PERM_AGENT_READ",
              "name": "PERM_AGENT_READ",
              "sequence": 29,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "9e953a5b-f131-499e-a68d-2c6ac76a0af5",
          "code": "PERM_SET_GEN_DOC_TEMP_CREATE",
          "sequence": 28,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "a2053285-988e-4cdd-a363-03783f591ec9",
              "code": "PERM_GEN_DOC_TEMP_CREATE",
              "name": "PERM_GEN_DOC_TEMP_CREATE",
              "sequence": 30,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "4a62514e-5c2c-4971-a188-5d7eed010811",
          "code": "PERM_SET_GEN_DOC_TEMP_UPDATE",
          "sequence": 29,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "05b4ab47-852c-4f43-af61-41de423d74cd",
              "code": "PERM_GEN_DOC_TEMP_UPDATE",
              "name": "PERM_GEN_DOC_TEMP_UPDATE",
              "sequence": 31,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "388a6463-3bbb-4f50-948b-7c8355e1990b",
          "code": "PERM_SET_GEN_DOC_TEMP_READ",
          "sequence": 30,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "e1474a10-5a19-41df-b3ed-ad18d7966144",
              "code": "PERM_GEN_DOC_TEMP_READ",
              "name": "PERM_GEN_DOC_TEMP_READ",
              "sequence": 32,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "f3e1c6b1-8c30-4ce8-9094-769308177ddc",
          "code": "PERM_SET_DOC_UPLOAD_CREATE",
          "sequence": 31,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "c49b2fb3-1dc7-4c2a-8388-0547c0d576dc",
              "code": "PERM_DOC_UPLOAD_CREATE",
              "name": "PERM_DOC_UPLOAD_CREATE",
              "sequence": 33,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "b833b2cb-2914-46ed-b363-587ceea3b4dc",
          "code": "PERM_SET_DOC_UPLOAD_UPDATE",
          "sequence": 32,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "ee744801-ef90-4cf2-ac69-a3f54a2462ca",
              "code": "PERM_DOC_UPLOAD_UPDATE",
              "name": "PERM_DOC_UPLOAD_UPDATE",
              "sequence": 34,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "61d3967a-7e51-470a-b205-ab5a78f2c5ce",
          "code": "PERM_SET_DOC_UPLOAD_READ",
          "sequence": 33,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "bb75d436-5586-4696-8b37-6c42ecd72e4b",
              "code": "PERM_DOC_UPLOAD_READ",
              "name": "PERM_DOC_UPLOAD_READ",
              "sequence": 35,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "25f3e691-3f40-4aaf-bf40-0bf886be3bd9",
          "code": "PERM_SET_JURISDICTION_CREATE",
          "sequence": 34,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "94ce055a-e627-450a-ab59-21d256dac12d",
              "code": "PERM_JURISDICTION_CREATE",
              "name": "PERM_JURISDICTION_CREATE",
              "description": null,
            }
          ]
        },
        {
          "permissionSetId": "1231d06a-010f-42c4-868e-353402a70a0f",
          "code": "PERM_SET_JURISDICTION_UPDATE",
          "sequence": 35,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "764d21fa-747c-40bf-b062-51f570150b91",
              "code": "PERM_JURISDICTION_UPDATE",
              "name": "PERM_JURISDICTION_UPDATE",
              "sequence": 37,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "208e37d0-e5f3-473f-b486-c6aceea654ea",
          "code": "PERM_SET_JURISDICTION_READ",
          "sequence": 36,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "32ee64bf-db64-46f4-9aba-e30d2afe5544",
              "code": "PERM_JURISDICTION_READ",
              "name": "PERM_JURISDICTION_READ",
              "sequence": 38,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "932f2d74-fc54-4f4a-9af6-e998d7e87da0",
          "code": "PERM_SET_COMPANY_INVOICING_UPDATE",
          "sequence": 37,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "801fdb99-8cb2-4082-af69-96cecf6c4013",
              "code": "PERM_COMPANY_INVOICING_CREATE",
              "name": "PERM_COMPANY_INVOICING_CREATE",
              "sequence": 39,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "befd5716-a459-4d6a-bb2d-e1cf7d0b2dd5",
          "code": "PERM_SET_COMPANY_INVOICING_UPDATE",
          "sequence": 38,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "8b25380d-e079-44d5-ab49-f6a3023ac0d0",
              "code": "PERM_COMPANY_INVOICING_UPDATE",
              "name": "PERM_COMPANY_INVOICING_UPDATE",
              "sequence": 40,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "fdca3b07-5599-4862-ae29-e85e60deaaeb",
          "code": "PERM_SET_COMPANY_INVOICING_READ",
          "sequence": 39,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "56f56133-273d-499e-bc30-139bcb9426fd",
              "code": "PERM_COMPANY_INVOICING_READ",
              "name": "PERM_COMPANY_INVOICING_READ",
              "sequence": 41,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "a4951c1a-8343-4ad9-9c2d-91a058f3b388",
          "code": "PERM_SET_MASTER_INFO_CREATE",
          "sequence": 40,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "af0f0c93-0b3c-48db-a066-fc9c0819147d",
              "code": "PERM_MASTER_INFO_CREATE",
              "name": "PERM_MASTER_INFO_CREATE",
              "sequence": 42,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "cb7d7ba8-1ef8-4ca0-8e00-39c8db361fb6",
          "code": "PERM_SET_MASTER_INFO_UPDATE",
          "sequence": 41,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "85d3ad19-1c2f-4a79-aa8d-a39ede60e068",
              "code": "PERM_MASTER_INFO_UPDATE",
              "name": "PERM_MASTER_INFO_UPDATE",
              "sequence": 43,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "b56b8585-dd7b-4361-b29a-54ccf86bddff",
          "code": "PERM_SET_MASTER_INFO_READ",
          "sequence": 42,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "725c1460-2a11-4aa2-a96e-257284c9b1dd",
              "code": "PERM_MASTER_INFO_READ",
              "name": "PERM_MASTER_INFO_READ",
              "sequence": 44,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "c8d5474b-5cf8-4db0-8c28-2bbce05e3b78",
          "code": "PERM_SET_EMAIL_TEMPLATE_CREATE",
          "sequence": 43,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "e19c651e-ecd7-4ec5-b1b4-bf27eb4ffa2f",
              "code": "PERM_EMAIL_TEMPLATE_CREATE",
              "name": "PERM_EMAIL_TEMPLATE_CREATE",
              "sequence": 45,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "f2aeb578-6fa4-4c1b-ac26-4ed63b151483",
          "code": "PERM_SET_EMAIL_TEMPLATE_UPDATE",
          "sequence": 44,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "2388bf87-3558-4670-8db2-257bc8ffe47a",
              "code": "PERM_EMAIL_TEMPLATE_UPDATE",
              "name": "PERM_EMAIL_TEMPLATE_UPDATE",
              "sequence": 46,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "7e0e3574-5e13-4f91-9119-ecbe04e23192",
          "code": "PERM_SET_EMAIL_TEMPLATE_READ",
          "sequence": 45,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "8ef56c57-1630-454d-a4c8-4bedfcba3a0a",
              "code": "PERM_EMAIL_TEMPLATE_READ",
              "name": "PERM_EMAIL_TEMPLATE_READ",
              "sequence": 47,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "a6672e54-b264-4d9d-a633-8c73ccd8a17a",
          "code": "PERM_SET_USER_TASK_CAR_SETUP",
          "sequence": 46,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "b6206c4b-978b-47b6-9fcf-196b5612e3af",
              "code": "PERM_USER_TASK_CAR_SETUP",
              "name": "PERM_USER_TASK_CAR_SETUP",
              "sequence": 48,
              "description": null,
              "type": "ADMIN"
            }
          ]
        },
        {
          "permissionSetId": "67af7588-249f-4001-8f13-654deba3f38c",
          "code": "PERM_SET_SYSTEM_SETTING_SETUP",
          "sequence": 47,
          "type": "ADMIN",
          "permissions": [
            {
              "permissionId": "ab1be38d-d8b0-4cd0-b772-a594a6a4a72b",
              "code": "PERM_SYSTEM_SETTING_SETUP",
              "name": "PERM_SYSTEM_SETTING_SETUP",
              "sequence": 49,
              "description": null,
              "type": "ADMIN"
            }
          ]
        }
      ]
    }
  ],
  "loginFailCount": 0,
  "isForceChangePassword": false,
  "userTokens": [
    {
      "userTokenId": "dc113583-d155-4fd9-808f-cd8fb163fa02",
      "userId": "433e1f06-37a7-460f-a7dc-6b810f7f2194",
      "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NjE4MDY4ODEzNCwiaXNzIjoiMTJmODIzYTAtMmZlMC00NWMyLTgzYjEtMDQ1MGM0NmE3ZTNhIiwiZGV2aWNlSWQiOiIifQ.Qs73rVkmEbMCLJ9noq5ttbPcWr2BYhKCAW0TMiu3i0AugyhnJhMKbit1B-naKRdTNERlaHhudRnLEk3dq9F8Jg",
      "createdDate": "2022-10-19T11:58:08.495+00:00",
      "lastAccessDate": "2022-10-19T12:01:09.820+00:00",
      "type": "NORMAL",
      "lastAccessIp": "0:0:0:0:0:0:0:1"
    }
  ],
  "lastLoginTime": null,
  "userPasswordType": "USER",
  "fullName": null,
  "enabled": true,
  "accountNonExpired": true,
  "accountNonLocked": true,
  "credentialsNonExpired": true,
  "authorities": [
    {
      "authority": "PERM_RECEIPT_UPDATE"
    },
    {
      "authority": "PERM_SET_DOC_UPLOAD_CREATE"
    },
    {
      "authority": "PERM_SET_GROUP_READ"
    },
    {
      "authority": "PERM_COMPANY_READ"
    },
    {
      "authority": "PERM_SET_DOC_UPLOAD_READ"
    },
    {
      "authority": "PERM_GEN_DOC_TEMP_CREATE"
    },
    {
      "authority": "PERM_SET_ROLE_READ"
    },
    {
      "authority": "PERM_SET_USER_CREATE"
    },
    {
      "authority": "PERM_COMPANY_INVOICING_READ"
    },
    {
      "authority": "PERM_SET_AGENT_READ"
    },
    {
      "authority": "PERM_WORKFLOW_FORM_UPDATE"
    },
    {
      "authority": "PERM_CASE_INFO_READ"
    },
    {
      "authority": "PERM_PROCESS_WORKFLOW_UPDATE"
    },
    {
      "authority": "PERM_ROLE_READ"
    },
    {
      "authority": "PERM_SET_PROCESSED_USER_TASK_READ"
    },
    {
      "authority": "PERM_PROCESSED_USER_TASK_READ"
    },
    {
      "authority": "PERM_SET_GROUP_CREATE"
    },
    {
      "authority": "PERM_SET_EMAIL_TEMPLATE_CREATE"
    },
    {
      "authority": "PERM_SET_ADMIN_LOGIN"
    },
    {
      "authority": "PERM_RECEIPT_CREATE"
    },
    {
      "authority": "PERM_USER_READ"
    },
    {
      "authority": "PERM_PROCESS_WORKFLOW_POST"
    },
    {
      "authority": "PERM_SET_JURISDICTION_CREATE"
    },
    {
      "authority": "PERM_RECEIPT_READ"
    },
    {
      "authority": "PERM_MASTER_INFO_READ"
    },
    {
      "authority": "PERM_SET_JURISDICTION_READ"
    },
    {
      "authority": "PERM_SET_COMPANY_READ"
    },
    {
      "authority": "PERM_PROCESS_WORKFLOW_READ"
    },
    {
      "authority": "PERM_MASTER_INFO_CREATE"
    },
    {
      "authority": "PERM_SET_PROCESS_WORKFLOW_DISCARD"
    },
    {
      "authority": "PERM_SET_CASE_INFO_READ"
    },
    {
      "authority": "PERM_ADMIN_LOGIN"
    },
    {
      "authority": "PERM_INDIVIDUAL_READ"
    },
    {
      "authority": "PERM_SET_GEN_DOC_TEMP_UPDATE"
    },
    {
      "authority": "PERM_JURISDICTION_UPDATE"
    },
    {
      "authority": "PERM_SYSTEM_SETTING_SETUP"
    },
    {
      "authority": "PERM_SET_USER_UPDATE"
    },
    {
      "authority": "PERM_SET_SYSTEM_SETTING_SETUP"
    },
    {
      "authority": "PERM_ROLE_CREATE"
    },
    {
      "authority": "PERM_GROUP_CREATE"
    },
    {
      "authority": "PERM_SET_RECEIPT_READ"
    },
    {
      "authority": "PERM_SET_PROCESS_WORKFLOW_CREATE"
    },
    {
      "authority": "PERM_SET_CASE_INFO_CREATE"
    },
    {
      "authority": "PERM_USER_UPDATE"
    },
    {
      "authority": "PERM_SET_ROLE_CREATE"
    },
    {
      "authority": "PERM_GEN_DOC_TEMP_READ"
    },
    {
      "authority": "PERM_SET_COMPANY_INVOICING_READ"
    },
    {
      "authority": "PERM_AGENT_READ"
    },
    {
      "authority": "PERM_SET_PROCESS_WORKFLOW_POST"
    },
    {
      "authority": "PERM_EMAIL_TEMPLATE_CREATE"
    },
    {
      "authority": "PERM_EMAIL_TEMPLATE_READ"
    },
    {
      "authority": "PERM_SET_USER_TASK_CAR_SETUP"
    },
    {
      "authority": "PERM_SET_MASTER_INFO_UPDATE"
    },
    {
      "authority": "PERM_SET_USER_READ"
    },
    {
      "authority": "PERM_SET_RECEIPT_UPDATE"
    },
    {
      "authority": "PERM_JURISDICTION_READ"
    },
    {
      "authority": "PERM_COMPANY_INVOICING_UPDATE"
    },
    {
      "authority": "PERM_SET_WORKFLOW_FORM_UPDATE"
    },
    {
      "authority": "PERM_SET_GEN_DOC_TEMP_CREATE"
    },
    {
      "authority": "PERM_GROUP_READ"
    },
    {
      "authority": "PERM_SET_COMPANY_INVOICING_UPDATE"
    },
    {
      "authority": "PERM_SET_RECEIPT_CREATE"
    },
    {
      "authority": "PERM_PROCESS_WORKFLOW_CREATE"
    },
    {
      "authority": "PERM_USER_CHANGE_SELF_PASSWORD"
    },
    {
      "authority": "PERM_CASE_INFO_CREATE"
    },
    {
      "authority": "PERM_SET_PROCESS_WORKFLOW_READ"
    },
    {
      "authority": "PERM_DOC_UPLOAD_UPDATE"
    },
    {
      "authority": "PERM_SET_EMAIL_TEMPLATE_UPDATE"
    },
    {
      "authority": "PERM_SET_CASE_INFO_UPDATE"
    },
    {
      "authority": "PERM_USER_SELF_READ"
    },
    {
      "authority": "PERM_SET_INDIVIDUAL_READ"
    },
    {
      "authority": "PERM_COMPANY_INVOICING_CREATE"
    },
    {
      "authority": "PERM_SET_COMPANY_INVOICING_UPDATE"
    },
    {
      "authority": "PERM_DOC_UPLOAD_CREATE"
    },
    {
      "authority": "PERM_SET_WORKFLOW_FORM_READ"
    },
    {
      "authority": "PERM_SET_GEN_DOC_TEMP_READ"
    },
    {
      "authority": "PERM_SET_MASTER_INFO_CREATE"
    },
    {
      "authority": "PERM_SET_DOC_UPLOAD_UPDATE"
    },
    {
      "authority": "PERM_JURISDICTION_CREATE"
    },
    {
      "authority": "PERM_GROUP_UPDATE"
    },
    {
      "authority": "PERM_SET_PROCESS_WORKFLOW_UPDATE"
    },
    {
      "authority": "PERM_SET_ROLE_UPDATE"
    },
    {
      "authority": "PERM_PROCESS_WORKFLOW_DISCARD"
    },
    {
      "authority": "PERM_WORKFLOW_FORM_READ"
    },
    {
      "authority": "PERM_SET_MASTER_INFO_READ"
    },
    {
      "authority": "PERM_CASE_INFO_UPDATE"
    },
    {
      "authority": "PERM_WORKFLOW_FORM_CREATE"
    },
    {
      "authority": "PERM_ROLE_UPDATE"
    },
    {
      "authority": "PERM_USER_TASK_CAR_SETUP"
    },
    {
      "authority": "PERM_SET_EMAIL_TEMPLATE_READ"
    },
    {
      "authority": "PERM_DOC_UPLOAD_READ"
    },
    {
      "authority": "PERM_SET_JURISDICTION_UPDATE"
    },
    {
      "authority": "PERM_EMAIL_TEMPLATE_UPDATE"
    },
    {
      "authority": "PERM_SET_WORKFLOW_FORM_CREATE"
    },
    {
      "authority": "PERM_SET_GROUP_UPDATE"
    },
    {
      "authority": "PERM_USER_CREATE"
    },
    {
      "authority": "PERM_GEN_DOC_TEMP_UPDATE"
    },
    {
      "authority": "PERM_MASTER_INFO_UPDATE"
    }
  ]
}
@Injectable(
  {
    providedIn: 'root'
  }
)
export class UserService {


  public getSelf(): Observable<User> {
    return of(userOne)
  }

  public forgotPassword(username: string, email: string): Observable<boolean> {



    return of(true)
  }

  public resetPassword(user: User, password: string): Observable<boolean> {

    return of(true)
  }

  public modifyPassword(originalPassword: string, password: string): Observable<boolean> {


    return of(true)
  }

  public resetPasswordByGenerate(userId: string): Observable<boolean> {


    return of(true)
  }
}